// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"b96b5742","484":"01cd66b0","573":"faa848b4"}[chunkId] + ".chunk.css";
};